import React, { useState } from 'react';
import { imageUrl } from '../lib/images';

export { imageUrl, imageUrl as optimizeAuxoUrl };

export default function CmsImage({
  src,
  alt = '',
  className = '',
  width = 800,
  loading = 'lazy',
  aspectRatio,
  onError,
  ...props
}) {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    return (
      <div
        className={`flex items-center justify-center bg-stone-100 text-stone-400 ${className}`}
        style={aspectRatio ? { aspectRatio } : undefined}
      >
        <i className="fa-solid fa-industry text-2xl text-stone-300" aria-hidden="true" />
      </div>
    );
  }

  const optimizedSrc = imageUrl(src, `width=${width},quality=80,format=auto`);

  return (
    <img
      src={optimizedSrc}
      alt={alt}
      loading={loading}
      className={`bg-transparent ${className}`}
      style={aspectRatio ? { aspectRatio } : undefined}
      onError={(e) => {
        setHasError(true);
        if (typeof onError === 'function') onError(e);
      }}
      {...props}
    />
  );
}
